import { BrandliveEvent } from '@/types/projects.types';

const getProjectNameURL = (eventBundle: BrandliveEvent) => {
  return eventBundle?.name.toLowerCase().replace(/[^0-9a-z]/g, '-') ?? '';
};

export default getProjectNameURL;
